(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.BestInterestRules",
                {
                    url: "/BestInterestRules",
                    component: "bestInterestRules",
                    PageTitle: "Best Interest Rules",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("bestInterestRules",
        {
            templateUrl: "App/Resources/BestInterestRules/BestInterestRules.template.html",
            controller: bestInterestRulesCtrl,
            bindings: {
                states: "<"
            }
        });

    bestInterestRulesCtrl.$inject = ["amplitudeService"];

    function bestInterestRulesCtrl(amplitudeService) {
        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        $ctrl.AdditionalResourceGroups = [
            {
                GroupName: 'Best Interest Resources',
                AdditionalResources: [
                    {
                        Icon: 'mdi mdi-48px file-pdf',
                        Name: 'NAIC Best Interest',
                        ExternalUrl: 'https://www.figmarketing.com/files/resources/NAIC_Best_Interest.pdf',
                    },
                    {
                        Icon: 'mdi mdi-48px file-pdf',
                        Name: 'NAIC Model #275 - Annuity Disclosure Form',
                        ExternalUrl: 'https://www.figmarketing.com/files/resources/NAIC_Model_275-Annuity_Disclosure_Form-Guidance.pdf',
                    },
                    {
                        Icon: 'mdi mdi-48px file-pdf',
                        Name: 'NAIC Model 275 - Disclosure Forms',
                        ExternalUrl: 'https://www.figmarketing.com/files/resources/NAIC_Model_275-Disclosure_Forms-Clean.pdf',
                    },
                    {
                        Icon: 'mdi mdi-48px file-pdf',
                        Name: 'NAIC Suitability MDL 275 Adoption - 04.07.21',
                        ExternalUrl: 'https://www.figmarketing.com/files/resources/NAIC_Suitability_MDL_275_Adoption-Current_Status(04.07.21).pdf',
                    },
                ]
            },
        ]
    }
})(window.app, window.angular); // jshint ignore:line